Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById('splash')) {
        Layout.components.splash = new Vue({
            el: document.getElementById("splash"),
            store,
            data: function () {
                return {
                    initiated: false,
                    leave: false,
                    splashShown: sessionStorage.getItem('splash')
                }
            },
            mounted() {
                const that = this;
                if(!that.splashShown) {
                    sessionStorage.setItem('splash', true);
                    that.initiated = true;

                    window.setTimeout(function () {
                        that.leave = true;
                    }, 1200);
                }
            }
        });
    }
});
